var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhoneicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 82,
    height: 82,
    viewBox: "0 0 82 82",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_122_40810)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 1,
    width: 78,
    height: 78,
    rx: 39,
    fill: "white",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2.5,
    y: 1.5,
    width: 77,
    height: 77,
    rx: 38.5,
    stroke: "#EAECF0",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.0137 52.5321C35.0149 51.5333 34.2017 50.2429 33.5741 48.6961C32.9643 47.1846 32.5135 45.4964 32.2218 43.7021C31.9478 41.9078 31.7975 40.0605 31.7799 38.1867C31.7887 36.304 31.939 34.4567 32.213 32.6801C32.5135 30.8593 32.9643 29.1888 33.5565 27.7304C34.1929 26.1747 35.0237 24.8842 36.0225 23.8855C36.7119 23.196 37.4897 22.6657 38.3383 22.2945C39.2133 21.9144 40.1944 21.7288 41.2374 21.7641C42.5898 21.773 43.7034 22.2149 44.5343 23.0458C44.879 23.3905 45.153 23.8236 45.3121 24.2655C45.4977 24.7693 45.5508 25.2997 45.4447 25.83L44.605 30.7709C44.5343 31.2129 44.4282 31.6018 44.278 31.9465C44.1277 32.3265 43.9244 32.6536 43.6681 32.9099C43.3322 33.2458 42.908 33.4756 42.413 33.5993C42.0417 33.7054 41.5821 33.7584 41.0695 33.7584L39.8409 33.785C39.8232 33.8203 39.8144 33.8468 39.8055 33.8733C39.726 34.165 39.6199 34.6954 39.5492 35.5792C39.4873 36.5073 39.4431 37.3647 39.4343 38.1867C39.4431 39.2208 39.4696 40.0605 39.5404 40.803C39.6199 41.7311 39.7348 42.2702 39.832 42.5619L39.7702 42.5884L41.0518 42.5973C41.5998 42.5973 42.0683 42.6591 42.4572 42.7829C43.2438 42.9685 43.9156 43.5342 44.278 44.4092C44.4106 44.7363 44.5255 45.1163 44.605 45.5671L45.4535 50.5876C45.5596 51.1356 45.5154 51.6571 45.321 52.1344C45.1177 52.6028 44.8702 52.9741 44.5608 53.2834C44.1365 53.7077 43.6151 54.0347 43.0317 54.2469C42.4483 54.459 41.8738 54.5739 41.2639 54.6004C40.2033 54.6534 39.2575 54.5032 38.3648 54.1231C37.5074 53.7607 36.7119 53.2304 36.0137 52.5321ZM43.2085 24.3716C42.7223 23.8855 42.0594 23.6468 41.2021 23.638C40.4154 23.6115 39.7171 23.744 39.0896 24.018C38.4443 24.292 37.8698 24.6898 37.3483 25.2113C36.5263 26.0333 35.828 27.1205 35.2977 28.4286C34.7585 29.7633 34.3431 31.2924 34.078 32.9718C33.8128 34.6512 33.6714 36.4013 33.6625 38.1779C33.6714 39.9368 33.8128 41.7046 34.078 43.4016C34.3343 45.0545 34.7497 46.6013 35.3154 47.9801C36.1816 50.1368 37.4456 51.7013 39.0984 52.3819C39.7348 52.647 40.4154 52.7619 41.1844 52.7177C41.6086 52.7001 42.0064 52.6205 42.4218 52.4703C42.7489 52.3553 43.0317 52.1786 43.2615 51.9488C43.4029 51.8073 43.5178 51.6394 43.6062 51.4096C43.6327 51.33 43.6769 51.1798 43.6239 50.8969L42.7754 45.8765C42.7223 45.576 42.6516 45.3285 42.5632 45.1163C42.4483 44.8423 42.4483 44.6832 41.9622 44.5683C41.697 44.4799 41.4053 44.4534 41.0518 44.4534L39.7171 44.4446C39.0365 44.4358 38.4267 43.985 38.1703 43.4281L38.0378 43.0834C37.8698 42.5266 37.7461 41.8018 37.6754 40.9356C37.6135 40.1489 37.5781 39.265 37.5693 38.1602C37.5781 37.2851 37.6135 36.3836 37.6842 35.4113C37.7549 34.5097 37.8698 33.7938 38.0289 33.2635L38.188 32.8922C38.3383 32.6359 38.4355 32.5033 38.5592 32.3796C38.8774 32.0614 39.2752 31.8934 39.7171 31.8934L41.0695 31.8669C41.423 31.8669 41.7235 31.8316 41.9622 31.7697C42.1478 31.7255 42.2716 31.6548 42.3599 31.5664C42.4307 31.4957 42.5102 31.3631 42.5721 31.2129C42.6516 31.0096 42.7135 30.7532 42.7577 30.4616L43.6062 25.5118C43.6416 25.2997 43.6239 25.1052 43.5532 24.9108C43.4736 24.7075 43.3587 24.5219 43.2085 24.3716ZM39.7613 42.5973L39.0189 43.0569L39.8762 42.6768C39.8409 42.6238 39.7967 42.5973 39.7613 42.5973Z",
    fill: "url(#paint0_linear_122_40810)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.4322 41.9696C48.0698 41.6072 48.0698 41.0062 48.4322 40.6438C48.7504 40.3256 49.0952 39.3445 49.1305 38.2485C49.1659 37.1701 48.9184 36.2686 48.4322 35.7824C48.0698 35.42 48.0698 34.819 48.4322 34.4566C48.7946 34.0942 49.3957 34.0942 49.7581 34.4566C50.6154 35.314 51.0574 36.6752 51.0043 38.3015C50.9513 39.8218 50.4652 41.2625 49.7581 41.9696C49.3957 42.332 48.7946 42.332 48.4322 41.9696Z",
    fill: "#292D32"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.5258 45.0633C51.1634 44.7009 51.1634 44.0999 51.5258 43.7375C54.5752 40.6881 54.5752 35.7383 51.5258 32.6889C51.1634 32.3265 51.1634 31.7255 51.5258 31.3631C51.8882 31.0007 52.4892 31.0007 52.8516 31.3631C56.6258 35.1373 56.6258 41.2891 52.8516 45.0633C52.4892 45.4257 51.8882 45.4257 51.5258 45.0633Z",
    fill: "#292D32"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_122_40810",
    x: 0,
    y: 0,
    width: 82,
    height: 82,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_122_40810"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_122_40810",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_122_40810",
    x1: 50.1823,
    y1: 28.6938,
    x2: 31.1788,
    y2: 47.6973,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DD5004"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EE1C2D"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneicon);
export default __webpack_public_path__ + "static/media/phoneicon.846cbdf40b2d5acee6fa7ab68e564e2b.svg";
export { ForwardRef as ReactComponent };